import React, { useState, useEffect, useMemo, useRef } from 'react';

const HeroSection = React.memo(() => {
  const [isVisible, setIsVisible] = useState(false);
  const [logoTransform, setLogoTransform] = useState({ rotateX: 0, rotateY: 0, scale: 1 });
  const sectionRef = useRef(null);
  const logoRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const titleStyle = useMemo(() => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
    transition: 'all 1.2s cubic-bezier(0.23, 1, 0.32, 1)',
    color: '#2C2C2C',
    letterSpacing: '0.05em',
    fontSize: 'clamp(3rem, 8vw, 6rem)',
    lineHeight: '1.2',
    fontWeight: '700',
    marginBottom: 'var(--space-8)',
    fontFamily: 'serif'
  }), [isVisible]);

  return (
    <section 
      id="主页" 
      className="hero" 
      aria-labelledby="hero-title"
      ref={sectionRef}
      style={{
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#FFFFFF',
        padding: 'var(--space-16) var(--space-8)',
        paddingTop: '120px'
      }}
    >
      <div className="hero-container" style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <h1 
          id="hero-title" 
          className="hero-title display-title"
          style={titleStyle}
        >
          御林安全工作室
        </h1>

        <div 
          style={{
            display: 'flex',
            gap: 'var(--space-12)',
            alignItems: 'flex-start',
            marginTop: 'var(--space-12)'
          }}
        >
          <div 
            style={{
              opacity: isVisible ?1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
              transition: 'all 1s cubic-bezier(0.23, 1, 0.32, 1) 0.8s',
              position: 'relative',
              flex: '0 0 auto'
            }}
          >
            <img 
              ref={logoRef}
              src="/logo.jpg" 
              alt="御林安全工作室Logo" 
              style={{
                transition: 'transform 0.1s ease-out',
                transform: `perspective(1000px) rotateX(${logoTransform.rotateX}deg) rotateY(${logoTransform.rotateY}deg) scale(${logoTransform.scale})`,
                borderRadius: 'var(--radius-2xl)',
                cursor: 'pointer',
                maxWidth: '400px',
                height: 'auto'
              }}
              onMouseMove={(e) => {
                if (!logoRef.current) return;
                const rect = logoRef.current.getBoundingClientRect();
                const centerX = rect.left + rect.width / 2;
                const centerY = rect.top + rect.height / 2;
                
                const percentX = (e.clientX - centerX) / (rect.width / 2);
                const percentY = (e.clientY - centerY) / (rect.height / 2);
                
                const clampedX = Math.max(-1, Math.min(1, percentX));
                const clampedY = Math.max(-1, Math.min(1, percentY));
                
                const rotateY = clampedX * 25;
                const rotateX = -clampedY * 25;
                
                const distance = Math.sqrt(clampedX * clampedX + clampedY * clampedY);
                const scale = 1 - distance * 0.1;
                
                setLogoTransform({ rotateX, rotateY, scale });
              }}
              onMouseLeave={() => {
                setLogoTransform({ rotateX: 0, rotateY: 0, scale: 1 });
              }}
            />
          </div>

          <div 
            className="intro-text"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
              transition: 'all 1s cubic-bezier(0.23, 1, 0.32, 1) 1s',
              flex: 1,
              background: 'transparent',
              padding: '0',
              border: 'none',
              borderRadius: '0',
              backdropFilter: 'none'
            }}
          >
            <h3 
              style={{
                fontSize: '1.5rem',
                fontWeight: '600',
                marginBottom: 'var(--space-6)',
                color: '#8B4513',
                fontFamily: 'serif'
              }}
            >
              关于我们
            </h3>
            
            <div style={{ 
              fontSize: '1.1rem', 
              lineHeight: '1.8',
              color: '#4A4A4A',
              textAlign: 'justify'
            }}>
              <p style={{ marginBottom: 'var(--space-4)', position: 'relative', paddingLeft: 'var(--space-4)' }}>
                御林安全工作室创立于2018年，依托于电子科技大学信息中心，专注于渗透测试、漏洞挖掘、代码审计、逆向破解等各大安全方向。
              </p>
              
              <p style={{ marginBottom: 'var(--space-4)', position: 'relative', paddingLeft: 'var(--space-4)' }}>
                我们拥有从本科生、研究生到博士生的多元化团队成员，不断参与国内外CTF、漏洞挖掘赛事，跟踪国内外最新安全动态，产出高质量安全研究文章与CVE。
              </p>
              
              <p style={{ marginBottom: 'var(--space-4)', position: 'relative', paddingLeft: 'var(--space-4)' }}>
                为电子科大校园网站提供专业安全服务，与行业内多家企业、政府相关部门保持紧密联系，承接校内外多个重要安全项目。
              </p>
              
              <p style={{ position: 'relative', paddingLeft: 'var(--space-4)' }}>
                定期举行技术分享活动，致力于为在校学生搭建信息安全领域人才培养和安全技术分享交流的优质平台。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default HeroSection;